import { useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { RootState } from '../store/store';
import { MAFIA_ROLES, NEUTRAL_ROLES, TOWN_ROLES } from '../types/roleEnum';
import { IRoleConfig } from '../types/IRoleConfig';
import Footer from './Footer';
import SubHeader from './SubHeader';
import './RolePopup.scss';


function RolePopup(props: { role: string, onCancel: () => void, exeTarget: number | null | undefined }) {
    const { defaultRoleConfig } = useSelector((state: RootState) => state.editor);
    const { playerView } = useSelector((state: RootState) => state.game);
    const [isOpen, setOpen] = useState(true);
    const [messages, setMessages] = useState([] as string[]);
    const [params, setParams] = useState([] as string[]);
    const { role, onCancel, exeTarget } = props;
    const [exeTargetName, setExeTargetName] = useState<string | null>(null);

    useEffect(() => {
        if (TOWN_ROLES.concat(MAFIA_ROLES).concat(NEUTRAL_ROLES).indexOf(role) !== -1) {
            const dynamicKey = role as keyof IRoleConfig;
            const roleConfig = defaultRoleConfig[dynamicKey];
            var messages: string[] = [];
            if (roleConfig) {
                messages.push(`Your role is ${role}`);
                if(exeTargetName) {
                    messages.push(`Your target is ${exeTargetName}`);
                }
                messages= messages.concat(roleConfig.description);
                setParams([
                    `is_night_immune: ${roleConfig.is_night_immune}`,
                    `is_sus: ${roleConfig.is_sus}`,
                    `only_self_action: ${roleConfig.only_self_action}`,
                    `can_target_self: ${roleConfig.can_target_self}`,
                    `action_count: ${roleConfig.action_count}`,
                    `action_cooldown: ${roleConfig.action_cooldown}`,
                ])
            } else {
                messages.push('Unknown Role');
            }
            setMessages(messages);
        }
    }, [role, exeTargetName])

    useEffect(() => {
        if(exeTarget && playerView) {
            const player = playerView!.other_players_state?.find(ops => ops.position === exeTarget);
            if(player) {
                setExeTargetName(player.name);
            }
        }
    }, [exeTarget])

    if (!isOpen) {
        return <></>
    }

    return <div className="mafia-container-wrapper">
        <div className="mafia-container">
            <SubHeader>
                Role Description
            </SubHeader>
            <div className='mafia-list-container mafia-role-description regular-text'>
                {messages.map(m => <div>{m}</div>)}
                {params.length > 0 &&
                    <div>
                        <hr />
                        <div className='mark'>Parameters:</div>
                        {params.map(p => {
                            let parsed = p.replaceAll('_', ' ');
                            if (parsed.length < 1) {
                                return <></>
                            }
                            parsed = parsed[0].toUpperCase() + parsed.substring(1);
                            const index = parsed.indexOf(':');
                            if (index > 0) {
                                return <div><span>{parsed.substring(0, index)}:</span><span className='mark'>{parsed.substring(index + 1)}</span></div>

                            }
                            return <div>{parsed}</div>
                        })}
                    </div>}
            </div>
        </div>
        <Footer>
            <button onClick={onCancel}>Ok</button>
        </Footer>
    </div>

}

export default RolePopup;